import React from 'react';
import {
  LoaderFunctionArgs,
  useLoaderData,
} from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

import { GET_PROMO_CODE } from '../promo-code/queries';
import { createApolloClient } from '../../providers/ApolloClientFactory';
import { PromoCode } from '../../types/promoCode';
import {gql} from "@apollo/client";
import {RFID} from "../../types/rfid";

const client = createApolloClient();

export const QrCodeDisplayLoader = async ({ params }: LoaderFunctionArgs) => {
  const { uid, event_id } = params;

  const RFID_BY_UID_QUERY = gql`
  query RfidListQuery($uid: String!, $event_id: Int!) {
    rfid_assets(where: { uid: { _eq: $uid }, event_id: { _eq: $event_id } }) {
      id
      uid
      is_active
      event_id
      reg_id
      attendee_id
      access_type
      tokens_balance
      promo_balance
      cash_balance
      notes
      attendee {
        id
        first_name
        last_name
      }
      event {
        name
      }
    }
  }
`;

  const { data } = await client.query({
    query: RFID_BY_UID_QUERY,
    variables: {
      event_id: event_id,
      uid: uid,
    },
  });
console.log({ data });
  return {
    data: data.rfid_assets?.[0],
    uid
  };
};

export const QrCodeDisplay = () => {
  const { data, uid } = useLoaderData() as {
    data: RFID;
    uid: string;
  };
  const tokensBalance = data?.tokens_balance;
  let tokenStrings;
  if (tokensBalance && Object.keys(tokensBalance).length > 0) {
    tokenStrings = Object.values<any>(tokensBalance).map(
        (token) => `${token.redeemable_token_name} - ${token.balance}`
    );
  }

  const cashBalance = data?.cash_balance || 0;
  const promoBalance = data?.promo_balance || 0;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        background: 'white',
        padding: '16px',
        height: '100vh',
      }}
    >
      <div>
        {data ? (
            <div>
              <h1 className="text-center text-2xl mb-2">
                <strong>{data?.event?.name}</strong>
              </h1>
              <p className="text-center">
                Present the QR Code below at any of our Point-of-Sale Terminals To Redeem
              </p>
              <div className="flex justify-center mt-5">
                <QRCodeSVG value={uid} width={'50vw'} height={'50vw'} />
              </div>
              <div className="flex flex-col justify-center mt-5">
                <p className="text-center">
                  <strong>UID:</strong> {data.uid}
                </p>
                {data.reg_id && (
                  <p className="text-center">
                    <strong>Print ID:</strong> {data.reg_id}
                  </p>
                )}
                {tokenStrings && (
                  <p className="text-center">
                    <strong>Token Balance:</strong> {tokenStrings.join(', ')}
                  </p>
                )}
                {cashBalance > 0 && (
                  <p className="text-center">
                    <strong>Cash Balance:</strong> ${(cashBalance / 100).toFixed(2)}
                  </p>
                )}
                {promoBalance > 0 && (
                  <p className="text-center">
                    <strong>Promo Balance:</strong> ${(promoBalance / 100).toFixed(2)}
                  </p>
                )}
              </div>
            </div>
        ) : (
            <div>
              <p className="text-center">
                See your Ticket QR Code Below:
              </p>
              <QRCodeSVG value={uid} width={'30vw'} height={'40vw'} />
            </div>
        )}
      </div>
    </div>
  );
};
